import React from 'react';
import PropTypes from 'prop-types';
import { buildContext } from '@coveo/headless';
import StandaloneSearchBox from './StandaloneSearchBox';
import { coveoSearchEngine } from '../ResultsListing/components/CoveoSearchEngine';
// import SuggestedQueries from './SuggestedQueries';

const HeaderSearch = ({
  coveoApiKey,
  coveoOrganizationId,
  coveoPipeline,
  coveoSearchHub,
  redirectUrl,
  searchInputPlaceholder,
  searchBtnLabel,
  // suggestedSearchersLabel,
  coveoSource,
  // timeToRenewInSec,
  coveoContext
}) => {
  const coveoHeadlessSearchEngine =
    coveoOrganizationId && coveoApiKey
      ? coveoSearchEngine(
          coveoOrganizationId,
          coveoApiKey,
          coveoPipeline,
          coveoSearchHub,
          false
        ) // set 3rd argument to true if you want to debug
      : coveoSearchEngine();

  if (coveoContext) {
    const context = buildContext(coveoHeadlessSearchEngine);

    context?.set(JSON.parse(coveoContext));
  }

  return (
    <div className="header-search__search-bar">
      <StandaloneSearchBox
        engine={coveoHeadlessSearchEngine}
        redirectUrl={redirectUrl}
        searchInputPlaceholder={searchInputPlaceholder}
        searchBtnLabel={searchBtnLabel}
        coveoSource={coveoSource}
      />
      {/* <div>
        <p className="suggested-searches__label">{suggestedSearchersLabel}</p>
        <SuggestedQueries
          coveoApiKey={coveoApiKey}
          coveoOrganizationId={coveoOrganizationId}
          coveoPipeline={coveoPipeline}
          coveoSearchHub={coveoSearchHub}
          coveoSource={coveoSource}
          timeToRenewInSec={timeToRenewInSec}
        />
      </div> */}
    </div>
  );
};

HeaderSearch.defaultProps = {
  searchBtnLabel: 'Search',
  searchInputPlaceholder: 'What are you looking for?',
  redirectUrl: '/search',
  suggestedSearchersLabel: 'Suggested Searches'
};

HeaderSearch.propTypes = {
  searchBtnLabel: PropTypes.string.isRequired,
  coveoApiKey: PropTypes.string,
  coveoOrganizationId: PropTypes.string,
  coveoPipeline: PropTypes.string,
  coveoSearchHub: PropTypes.string,
  searchInputPlaceholder: PropTypes.string,
  redirectUrl: PropTypes.string,
  suggestedSearchersLabel: PropTypes.string,
  coveoSource: PropTypes.string,
  timeToRenewInSec: PropTypes.string,
  coveoContext: PropTypes.string
};

export default HeaderSearch;
